define('home/utils/backboneUtils',[
    'jquery',
], function (
    $
) {
    'use strict';

    return {
        memoizedFetch: function () {
            if (this.fetchPromise)
                return this.fetchPromise;

            var self = this;
            this.fetchPromise = this.constructor.__super__.fetch.apply(this, arguments).then(function () {
                self.fetchPromise = null;
                self.fetched = true;
                return arguments;
            }, function (err) {
                self.fetchPromise = null;
                // Leave self.fetched as its current value, true if at least 1 successful fetch, undefined otherwise
                return err;
            });

            return this.fetchPromise;
        },

        getPromiseFor: function (model, attributeName) {
            var attributeValue = $.Deferred();

            // Model.has() returns true if the value is non-null/undefined. Because "", false, {}, and 0 are
            // valid values for many attributes, we should resolve the attribute here because they will
            // likely never change.
            if (model.has(attributeName)) {
                attributeValue.resolve(model.get(attributeName));
            } else {
                model.once('change:' + attributeName, function (_model, value) {
                    attributeValue.resolve(value);
                });
            }

            return attributeValue.promise();
        },
    };
});

